import {find as _find} from 'lodash';
import {Utils} from '../../Utils/Utils';
import {ArgValidator} from '../../Utils/ArgValidator';
import {ICleanup} from '../../Utils/CommonTypes';
import {PreloaderResourceLoader} from './PreloaderResourceLoader';
import {PreloaderResourceItem} from './PreloaderResourceItem';

export abstract class PreloaderProviderBase implements ICleanup {
    abstract get resourceLoader(): PreloaderResourceLoader;

    abstract get audioResourceLoader(): PreloaderResourceLoader;

    abstract parseElements(): Promise<any>;

    abstract parseCurrentElements(): void;

    abstract loadGroupCompleted(group: string): void;

    abstract handleGroupError(error: any, group: string): void

    abstract loadCompleted(): Promise<any>;

    abstract onUpdateProgress(progress: number): void

    abstract cleanup(): void;

    abstract prepareFileList(resources: Array<PreloaderResourceItem>): void;

    public resourceHasFlag(resource: PreloaderResourceItem, flag: string): boolean {
        ArgValidator.ensureIsNotNullOrUndefined(resource, 'resource');
        ArgValidator.ensureStringIsNotNullOrEmpty(flag, 'flag');

        return !Utils.isNullOrUndefined(resource.flags) &&
               _find(resource.flags, f => f === flag) != null;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Preloader/Types/PreloaderProviderBase.ts
 **/